import React, { Component } from 'react';
//import PropTypes from 'prop-types';
//import queryString from 'query-string';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';
import { BlankCell, IconButtonCell, DropDownFilterCell, BooleanCell } from "../components/utils/GridHelpers";
//import VendorListing from './VendorListing';
//import VendorSuggestedOrders from './VendorSuggestedOrders';
import { getExportFileName, isEmpty } from '../helpers';
import isPage from '../hoc/isPage';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import EditSeasonPage from './EditSeasonPage';
import moment from 'moment';

import { AppContext } from '../context/AppContext'
//import ReportsListingPage from './ReportsListingPage';

const ADJUST_PADDING = 0;
const COLUMN_MIN = 4;
const MONTHS = [""].concat(moment.months());

class PartSeasonsPage extends Component {

    minGridWidth = 0;

    constructor(props) {
        super(props);

        this.state = {
            seasons: [],

            showDialog: false,
            selectedSeason: null,

            //columns: [],
            setMinWidth: false,
            gridCurrent: 0,
        }
    };

    componentDidMount() {
        this.prepareForDataLoad();
    }

    componentDidUpdate(prevProps) {
        const { orgType/*, childDealerships*/ } = this.context.state;
        let selectedSeasonOrg = this.props.getFromSessionStorage("selectedSeasonOrg");
        let apiUrl = '';
        if (prevProps.uiLanguage !== this.props.uiLanguage) {
            if (orgType === "dealer") {
                apiUrl = `/api/portal/season/${this.context.state.orgID}`;
            } else if (orgType === "dealergroup") {
                // get the selectedSeasonOrg
                if (selectedSeasonOrg) {
                    apiUrl = `/api/portal/season/${selectedSeasonOrg.orgID}`;
                }
            }
            let MONTHS = this.loadMonths();
            this.props.getData(apiUrl).then(response => {
                this.grid = document.querySelector('.k-grid');
                window.addEventListener('resize', this.handleResize);
                this.setState({
                    seasons: response.data.map((season, index) => Object.assign({
                        startMonthName: (season.startMonth && season.startMonth > 0 && season.startMonth < 13) ? MONTHS[season.startMonth] : null,
                        endMonthName: (season.endMonth && season.endMonth > 0 && season.endMonth < 13) ? MONTHS[season.endMonth] : null
                    }, season)),
                });
            }).catch(error => {
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0297"))
            });
        }
    }

    loadMonths = () => {
        moment.locale(this.props.uiLanguage);
        return [""].concat(moment.months());
    }

    prepareForDataLoad = () => {
        //let vendors;

        const { orgType, childDealerships } = this.context.state;
        //let { selectedSeasonOrg } = this.context.state;
        let selectedSeasonOrg = this.props.getFromSessionStorage("selectedSeasonOrg")

        // if no currently selected org, and we have a list of child dealerships, then just select the first dealership in the list
        if (isEmpty(selectedSeasonOrg) && !isEmpty(childDealerships)) {
            selectedSeasonOrg = childDealerships[0];
            //this.context.setState({ selectedSeasonOrg })

            this.props.saveToSessionStorage("selectedSeasonOrg", selectedSeasonOrg)
        }

        let apiUrl = '';

        if (orgType === "dealer") {
            apiUrl = `/api/portal/season/${this.context.state.orgID}`;
        } else if (orgType === "dealergroup") {
            // get the selectedSeasonOrg
            if (selectedSeasonOrg) {
                apiUrl = `/api/portal/season/${selectedSeasonOrg.orgID}`;
            }
        }

        if (!isEmpty(apiUrl)) {
            this.loadData(apiUrl);
        }
    }

    loadData = (apiUrl) => {
        let MONTHS = this.loadMonths();
        this.props.getData(apiUrl).then(response => {
            this.grid = document.querySelector('.k-grid');
            window.addEventListener('resize', this.handleResize);
            this.setState({
                seasons: response.data.map((season, index) => Object.assign({
                    startMonthName: (season.startMonth && season.startMonth > 0 && season.startMonth < 13) ? MONTHS[season.startMonth] : null,
                    endMonthName: (season.endMonth && season.endMonth > 0 && season.endMonth < 13) ? MONTHS[season.endMonth] : null
                }, season)),

                //columns: columns,
                gridCurrent: this.grid.offsetWidth,
                setMinWidth: this.grid.offsetWidth < this.minGridWidth,
            });
        }).catch(error => {

            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0297"))

        });
    }

    handleChangeDealer = (e) => {

        const { orgType } = this.context.state;
        const selectedSeasonOrg = e.target.value;

        // save this to session storage
        this.props.saveToSessionStorage('selectedSeasonOrg', selectedSeasonOrg);

        // this.context.setState({
        //     selectedSeasonOrg: selectedSeasonOrg
        // });

        // refresh list of vendors

        let apiUrl = '';

        if (orgType === "dealer") {
            apiUrl = `/api/portal/season/${this.context.state.orgID}`;
        } else if (orgType === "dealergroup") {
            // get the selectedSeasonOrg
            if (selectedSeasonOrg) {
                apiUrl = `/api/portal/season/${selectedSeasonOrg.orgID}`;
            }
        }

        if (!isEmpty(apiUrl)) {
            this.loadData(apiUrl);
        }
    }

    handleResize = () => {
        //console.log("grid.offsetWidth: ", this.grid.offsetWidth);

        if (this.grid) {
            if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
                this.setState({
                    setMinWidth: true
                });
            } else if (this.grid.offsetWidth > this.minGridWidth) {
                this.setState({
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: false
                });
            }
        }
    }

    setWidth = (minWidth, percentage) => {
        //console.log("state.gridCurrent: ", this.state.gridCurrent);
        //if (this.grid)
        //    console.log("grid.offsetWidth: ", this.grid.offsetWidth);
        //let columnsLength;
        //if (this.context.state.allowEditSuggestedOrders)
        //    columnsLength = columnsAllowEdit.length;
        //else
        //    columnsLength = columnsNotAllowEdit.length;
        //let width = this.state.setMinWidth ? minWidth :
        //    minWidth + (this.state.gridCurrent - this.minGridWidth) / columnsLength;
        let width = this.state.setMinWidth ? minWidth :
            Math.round(this.state.gridCurrent / 100 * percentage);
        width = width < COLUMN_MIN ? width : width - ADJUST_PADDING;
        //console.log("width: ", width);
        return width;
    }

    handleAddSeasonClick = (e) => {
        this.setState({
            showDialog: true,
            selectedSeason: null
        });
    }

    handleEditClick = (e, props) => {

        // bring up the dialog
        this.setState({
            showDialog: true,
            selectedSeason: props.dataItem
        })
    }

    handleCloseModal = (elmnt, payload) => {

        if (payload) {
            const seasons = this.state.seasons;
            let season = seasons.find(season => season.seasonID === payload.seasonID);

            if (season) {
                season.seasonID = payload.seasonID;
                season.seasonName = payload.seasonName;
                season.startMonth = payload.startMonth;
                season.startDay = payload.startDay;
                season.endMonth = payload.endMonth;
                season.endDay = payload.endDay;
                season.inactive = payload.inactive;
                season.startMonthName = (payload.startMonth && payload.startMonth > 0 && payload.startMonth < 13) ? MONTHS[payload.startMonth] : null;
                season.endMonthName = (payload.endMonth && payload.endMonth > 0 && payload.endMonth < 13) ? MONTHS[payload.endMonth] : null;
                season.modifiedBy = this.context.state.userName;
            }
            else {
                seasons.push({
                    seasonID: payload.seasonID,
                    seasonName: payload.seasonName,
                    startMonth: payload.startMonth,
                    startDay: payload.startDay,
                    endMonth: payload.endMonth,
                    endDay: payload.endDay,
                    inactive: payload.inactive,
                    startMonthName: (payload.startMonth && payload.startMonth > 0 && payload.startMonth < 13) ? MONTHS[payload.startMonth] : null,
                    endMonthName: (payload.endMonth && payload.endMonth > 0 && payload.endMonth < 13) ? MONTHS[payload.endMonth] : null,
                    modifiedBy: this.context.state.userName
                });
            }

            //console.log('user name is ' + this.context.state.userName);

            this.setState({
                showDialog: false,
                selectedSeason: null,
                seasons: seasons
            });
        }
        else
            this.setState({
                showDialog: false,
                selectedSeason: null
            });
    }

    render() {
        const { orgType, childDealerships } = this.context.state;
        let tabs, title;
        let previousPageTitle;
        let previousPageUrl;

        title = this.props.returnLocalizedString("m0298");
        tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={this.props.returnLocalizedString("m0298")} ></Tab>
        </Tabs>);

        //content = (<VendorListing handleChooseVendor={this.handleChooseVendor} orderType={this.state.orderType} />);
        let dealerPicker = <React.Fragment />

        let orgID;
        let orgName;

        if (orgType === "dealer") {
            orgID = this.context.state.orgID;
            //orgName = this.context.state.orgName;
        } else if (orgType === "dealergroup") {
            //debugger;
            let selectedSeasonOrg = this.props.getFromSessionStorage("selectedSeasonOrg");

            if (isEmpty(selectedSeasonOrg) && !isEmpty(childDealerships)) {
                //debugger;
                selectedSeasonOrg = childDealerships[0];
            }

            // get the selectedSeasonOrg
            if (selectedSeasonOrg) {
                orgID = selectedSeasonOrg.orgID;
                orgName = selectedSeasonOrg.orgName;
            }

            dealerPicker = (
                <form className="bottom-margin-60" style={{ backgroundColor: 'white', width: '100%', padding: '20px' }}>
                    <div className="search-controls">

                        <label htmlFor="dealer" className="padding-right-10">{this.props.returnLocalizedString("m0299")}</label>
                        <DropDownList id="selectedDealer"
                            name="selectedDealer"
                            value={selectedSeasonOrg}
                            data={childDealerships}
                            textField="orgName"
                            dataItemKey="orgID"

                            onChange={this.handleChangeDealer}
                        />
                    </div></form>);
        }

        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;

        // 448px is the perfect width with the current css styles
        let perfectSeasonDialogWidth = 448;
        let seasonDialogWidth = `${perfectSeasonDialogWidth}px`;
        if (this.state.showDialog) {
            this.dialogWrapper = document.querySelector('.k-dialog-wrapper');
            if (this.dialogWrapper)
                if (this.dialogWrapper.offsetWidth < perfectSeasonDialogWidth)
                    seasonDialogWidth = `${this.dialogWrapper.offsetWidth}px`;
        }

        let fileName = "Part-Seasons";
        if (!isEmpty(orgName)) {
            fileName = `${orgName.replace(/\s/g, '-')}-${fileName}`;
        }

        //!DBTRANS! @m0004@ Home !DEVNOTE! Option label
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0095@ Inactive !DEVNOTE! Form fields
        //!DBTRANS! @m0297@ Unable to get the list of seasons for this dealer. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0298@ Part Seasons !DEVNOTE! Title
        //!DBTRANS! @m0299@ Dealer: !DEVNOTE! Column label
        //!DBTRANS! @m0300@ Create new season !DEVNOTE! Column label
        //!DBTRANS! @m0301@ Season Name!DEVNOTE! Column label
        //!DBTRANS! @m0302@ Start Month !DEVNOTE! Column label
        //!DBTRANS! @m0303@ Start Day !DEVNOTE! Column label
        //!DBTRANS! @m0304@ End Month !DEVNOTE! Column label
        //!DBTRANS! @m0305@ End Day !DEVNOTE! Column label

        return (
            <div>
                <Header title={title} tabs={tabs} previousPageTitle={previousPageTitle} previousPageUrl={previousPageUrl} >

                </Header>

                <section className="page-content grid-row">
                    {dealerPicker}
                    <GridContainer
                        data={this.state.seasons}
                        sortColumn="seasonName"
                        excelFilename={getExportFileName(fileName)}

                    >
                        <GridContainerToolbar>
                            <GridContainerToolbarOption type="add" tooltip="m0300" primary={true} handleClick={this.handleAddSeasonClick} />
                        </GridContainerToolbar>

                        <Column
                            title={this.props.returnLocalizedString("m0301")}
                            field="seasonName"
                            width={this.setWidth(20, 25)}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0302")}
                            field="startMonthName"
                            width={this.setWidth(20, 12)}
                            filterCell={(props) => <DropDownFilterCell data={this.orgTypes}  {...props} />}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0303")}
                            field="startDay"
                            headerClassName="numeric"
                            className="numeric"
                            width={this.setWidth(20, 12)}
                            filterCell={(props) => <DropDownFilterCell data={this.countries}  {...props} />}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0304")}
                            field="endMonthName"
                            width={this.setWidth(20, 12)}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0305")}
                            field="endDay"
                            headerClassName="numeric"
                            className="numeric"
                            width={this.setWidth(20, 12)}
                        />
                        <Column
                            title={this.props.returnLocalizedString("m0095")}
                            field="inactive"
                            headerClassName="boolean"
                            className="boolean"
                            width={this.setWidth(20, 12)}
                            filter="boolean" cell={(props) =>
                                <BooleanCell {...props} />
                            } />
                        <Column
                            filterable={false}
                            sortable={false}
                            reorderable={false}
                            width={this.setWidth(20, 6)}
                            cell={(props) => (
                                <IconButtonCell handleClick={(e) => { this.handleEditClick(e, props) }} icon="Edit" {...props} />
                            )}
                            editable={false}
                        />
                        <Column
                            filterable={false}
                            resizable={false}
                            sortable={false}
                            reorderable={false}
                            cell={(props) => (
                                <BlankCell {...props} />
                            )}
                            editable={false}
                        />
                    </GridContainer>
                </section>
                {this.state.showDialog && (
                    <Dialog
                        className="edit"
                        style={{ top: top }}
                        width={seasonDialogWidth}
                        minWidth={320}
                        closeIcon={false}
                    >
                        <EditSeasonPage
                            handleCloseModal={this.handleCloseModal}
                            orgID={orgID}
                            season={this.state.selectedSeason} />
                    </Dialog>)
                }
            </div>
        );
    }
}
export default isPage(PartSeasonsPage);
PartSeasonsPage.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/PartSeasonsPage.js